import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _5a3a5afe = () => interopDefault(import('./prismic/pages/preview.vue' /* webpackChunkName: "" */))
const _4ae822be = () => interopDefault(import('../../../pages/mobile/index.vue' /* webpackChunkName: "pages/mobile/index" */))
const _027f2d76 = () => interopDefault(import('../../../pages/dashboard/_id.vue' /* webpackChunkName: "pages/dashboard/_id" */))
const _6437ce49 = () => interopDefault(import('../../../pages/faq/_faq.vue' /* webpackChunkName: "pages/faq/_faq" */))
const _6a65213a = () => interopDefault(import('../../../pages/loading/_session.vue' /* webpackChunkName: "pages/loading/_session" */))
const _681e632c = () => interopDefault(import('../../../pages/preview/_id.vue' /* webpackChunkName: "pages/preview/_id" */))
const _0a51694c = () => interopDefault(import('../../../pages/specs/_spec.vue' /* webpackChunkName: "pages/specs/_spec" */))
const _1b6f5409 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _d886ba28 = () => interopDefault(import('../../../pages/_template/_step.vue' /* webpackChunkName: "pages/_template/_step" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/preview",
    component: _5a3a5afe,
    name: "prismic-preview"
  }, {
    path: "/mobile",
    component: _4ae822be,
    name: "mobile"
  }, {
    path: "/dashboard/:id?",
    component: _027f2d76,
    name: "dashboard-id"
  }, {
    path: "/faq/:faq?",
    component: _6437ce49,
    name: "faq-faq"
  }, {
    path: "/loading/:session?",
    component: _6a65213a,
    name: "loading-session"
  }, {
    path: "/preview/:id?",
    component: _681e632c,
    name: "preview-id"
  }, {
    path: "/specs/:spec?",
    component: _0a51694c,
    name: "specs-spec"
  }, {
    path: "/",
    component: _1b6f5409,
    name: "index"
  }, {
    path: "/:template/:step?",
    component: _d886ba28,
    name: "template-step"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
